import { ClientOnly as ClientOnlyUtil } from "remix-utils/client-only";

/**
 * Wrapper so that we don't need to write repeatedly the children render pattern
 */
export default function ClientOnly({ children, ...props }) {
  return <ClientOnlyUtil {...props}>{() => children}</ClientOnlyUtil>;
}
